import React from 'react';
import {
  Tabs,
  Flex,
  Stack,
  VStack,
  useBreakpointValue,
  Text
} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout'
import CorporateTabPanel from './corporatetabpanel'
import ColumbiaCorporatePanel from './columbiacorporatepanel'
import SorelCorporatePanel from './sorelcorporatepanel'
import MountainHardwearCorporatePanel from './mhwcorporatepanel'
import PranaCorporatePanel from './prAnacorporatepanel'
import leadershipHeroImg from '../../components/ui/ourcompany/leadership/Alternate-Leadership-Team-Image.png'


export default function OurLeadership() {

  return (
    <HomeLayout align="left">
      <Flex
        w={'full'}
        h={'60vh'}
        className='page-banner'
        backgroundImage={`url(${leadershipHeroImg})`}
        backgroundSize={'cover'}
        backgroundPosition={'center center'}
        id="strategyMissionValuesHeroImg"
        title={`READY FOR YOUR NEXT ADVENTURE?\nLET’S EXPLORE!`}
      >
        <VStack
          w={'full'}
          justify={'center'}
          align={'left'}
          px={useBreakpointValue({ base: 4, md: 8 })}
          bgGradient="to-r"
          gradientFrom={"blackAlpha.600"}
          gradientTo={"transparent"}
        >
          <Stack maxW={'2xl'} spacing={6}>
            <Text
              align="center"
              color={'white'}
              fontWeight={600}
              lineHeight={1.2}
              fontSize={useBreakpointValue({
                base: '2xl',
                md: '4xl',
                sm: '3xl',
              })}
              mb="10px"
              id="officersanddirectorstext"
            >
              OFFICERS & DIRECTORS
            </Text>
          </Stack>
        </VStack>
      </Flex>
      <Tabs.Root
        lazyMount unmountOnExit fitted
        defaultValue={'corporate'}
        w="full"
      >
        <Tabs.List>
          <Tabs.Trigger value="corporate">Corporate</Tabs.Trigger>
          <Tabs.Trigger value="columbia">Columbia</Tabs.Trigger>
          <Tabs.Trigger value="sorel">SOREL</Tabs.Trigger>
          <Tabs.Trigger value="mhw">Mountain Hardwear</Tabs.Trigger>
          <Tabs.Trigger value="prana">prAna</Tabs.Trigger>
        </Tabs.List>


          <Tabs.Content value="corporate">
            <CorporateTabPanel />
          </Tabs.Content>
          <Tabs.Content value="columbia">
            <ColumbiaCorporatePanel />
          </Tabs.Content>
          <Tabs.Content value="sorel">
            <SorelCorporatePanel />
          </Tabs.Content>
          <Tabs.Content value="mhw">
            <MountainHardwearCorporatePanel />
          </Tabs.Content>
          <Tabs.Content value="prana">
            <PranaCorporatePanel />
          </Tabs.Content>

      </Tabs.Root>
    </HomeLayout>
  );
}
